/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export type paths = {
  '/customers/{partyId}/mapped-survey': {
    delete?: never;
    /**
     * Fetch template mapping for a natural customer.
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getNaturalCustomerMappedSurveyExport'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/customers/legal/{ledId}/mapped-survey': {
    delete?: never;
    /**
     * Fetch template mapping for a legal customer.
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getLegalCustomerMappedSurveyExport'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/export/backfill/surveys': {
    delete?: never;
    /**
     * Backfill survey submitted events for data lake ingestion. Paginates by customer UUID cursor.
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['backfillSurveys'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/export/backfill/templates': {
    delete?: never;
    /**
     * Backfill template updated events for data lake ingestion.
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['backfillTemplates'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/surveys/kyc/{country_code}/onboarding': {
    delete?: never;
    /**
     * Get KYC survey answers for account onboarding process
     * @deprecated
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:onboarding:read', 'knowYourCustomer:onboarding:write')`
     */
    get: operations['getKycSurveyResponseForNewAccount'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Post KYC survey answers for account onboarding process
     * @deprecated
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:onboarding:write')`
     */
    post: operations['postKycSurveyResponse_1'];
    put?: never;
    trace?: never;
  };
  '/surveys/kyc/{country_code}/withdrawal': {
    delete?: never;
    /**
     * Get survey questions for a new withdrawal
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getWithdrawalSurvey'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Save withdrawal survey answers
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:write')`
     */
    post: operations['postWithdrawalSurveyResponse'];
    put?: never;
    trace?: never;
  };
  '/v2/admin/customers/{customer_id}/answers/{answer_id}': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    /**
     * Update a customer answer's delete date.
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:admin:write')`
     */
    patch: operations['updateDeleteDate'];
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v2/admin/customers/search': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    /**
     * List all answers for given customer.
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:admin:read', 'knowYourCustomer:admin:write')`
     */
    put: operations['getCustomerAnswers'];
    trace?: never;
  };
  '/v2/admin/customers/search/pdf': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    /**
     * Get all customers know-your-customer answers in pdf format.
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:rightOfAccess:read')`
     */
    put: operations['exportPdf'];
    trace?: never;
  };
  '/v2/admin/mapping/{country_code}/{customer_type}/{version}': {
    delete?: never;
    /**
     * Get template mappings by country code, customer type, and version
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:admin:read', 'knowYourCustomer:admin:write')`
     */
    get: operations['getTemplateMappings'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v2/admin/survey': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Post a survey template with CM1 mapping.
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:admin:write')`
     */
    post: operations['postSurveyTemplate'];
    put?: never;
    trace?: never;
  };
  '/v2/admin/survey/{country_code}/{customer_type}': {
    delete?: never;
    /**
     * Get a survey template.
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:admin:read', 'knowYourCustomer:admin:write')`
     */
    get: operations['getSurveyTemplate'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v2/export': {
    delete?: never;
    /**
     * Get all customers know-your-customer answers.
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['export'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v2/surveys/kyc/{id}': {
    delete?: never;
    /**
     * Get available KYC surveys answers
     * @deprecated
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getKycSurveyResponse_2'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Post KYC survey answers
     * @deprecated
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:write')`
     */
    post: operations['postKycSurveyResponse_4'];
    put?: never;
    trace?: never;
  };
  '/v2/surveys/kyc/{id}/all': {
    delete?: never;
    /**
     * Get all KYC surveys answers
     * @deprecated
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getAllKycSurveyResponse'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v2/surveys/kyc/{id}/status': {
    delete?: never;
    /**
     * Get KYC status.
     * @deprecated
     * @description Get status of survey
     *
     *     ## Links returned
     *
     *     | Attribute                 | Type    | Description    |
     *     | ------------------------- | ------- | -------------- |
     *     | `status`                  | `href`  | Get status.    |
     *     | `questions`               | `href`  | Get questions. |
     *
     *
     *     ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getStatus_1'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v2/surveys/kyc/countries': {
    delete?: never;
    /**
     * Get a list of all countries
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getAllCountries'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v2/surveys/kyc/status': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    /**
     * KYC survey response status
     * @deprecated
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:write')`
     */
    put: operations['getKycSurveyStatus_2'];
    trace?: never;
  };
  '/v2/surveys/kyc/status/expire': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    /**
     * Get KYC expiration time
     * @deprecated
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:write')`
     */
    put: operations['getExpirationStatus_1'];
    trace?: never;
  };
  '/v3/surveys/kyc/{country_code}/onboarding': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Post KYC survey answers for account onboarding process
     * @deprecated
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:onboarding:write')`
     */
    post: operations['postKycSurveyResponse_5'];
    put?: never;
    trace?: never;
  };
  '/v3/surveys/kyc/{id}': {
    delete?: never;
    /**
     * Get available KYC surveys answers
     * @deprecated
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getKycSurveyResponse_1'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Post KYC survey answers
     * @deprecated
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:write')`
     */
    post: operations['postKycSurveyResponse_2'];
    put?: never;
    trace?: never;
  };
  '/v3/surveys/kyc/{id}/all': {
    delete?: never;
    /**
     * Get all KYC surveys answers
     * @deprecated
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getAllKycSurveyResponse_1'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v3/surveys/kyc/{id}/status': {
    delete?: never;
    /**
     * Get KYC status.
     * @deprecated
     * @description Get status of survey
     *
     *     ## Links returned
     *
     *     | Attribute                 | Type    | Description    |
     *     | ------------------------- | ------- | -------------- |
     *     | `status`                  | `href`  | Get status.    |
     *     | `questions`               | `href`  | Get questions. |
     *
     *
     *     ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getStatus_2'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v3/surveys/kyc/status': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    /**
     * KYC survey response status
     * @deprecated
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:write')`
     */
    put: operations['getKycSurveyStatus'];
    trace?: never;
  };
  '/v3/surveys/kyc/status/expire': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    /**
     * Get KYC expiration time
     * @deprecated
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:write')`
     */
    put: operations['getExpirationStatus'];
    trace?: never;
  };
  '/v4/kyc/party/{partyId}/surveys': {
    delete?: never;
    /**
     * Get unanswered KYC surveys by party ID
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read')`
     */
    get: operations['getSurveys'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v4/kyc/party/{partyId}/surveys/all': {
    delete?: never;
    /**
     * Get all KYC surveys by party ID
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read')`
     */
    get: operations['getAllSurveys'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v4/surveys/kyc/{country_code}/onboarding': {
    delete?: never;
    /**
     * Get KYC survey for account onboarding process
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:onboarding:read', 'knowYourCustomer:onboarding:write')`
     */
    get: operations['getKycSurveyForNewAccount'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Post KYC survey answers for account onboarding process
     * @description Saves KYC survey answers for an onboarding customer. The government_id in the request body identifies the customer and is required. The account_number is optional; when provided, non-general group answers (i.e. product-specific questions) are associated with that account number, while general group answers (i.e. groups not tied to a specific account, as configured per customer type) remain unchanged. Important: for KYC to be associated with an account, either provide account_number here or update the survey key to the account number in the request. If neither is done, the KYC answers will not be linked to the account.
     *
     *
     *
     *     ## Authorization
     *     `hasAuthority('knowYourCustomer:onboarding:write')`
     */
    post: operations['postKycSurveyResponse_3'];
    put?: never;
    trace?: never;
  };
  '/v4/surveys/kyc/{id}': {
    delete?: never;
    /**
     * Get unanswered KYC surveys
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getKycSurveyResponse'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Post KYC survey answers using the ID on the survey from the GET endpoint
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:write')`
     */
    post: operations['postKycSurveyResponse'];
    put?: never;
    trace?: never;
  };
  '/v4/surveys/kyc/{id}/all': {
    delete?: never;
    /**
     * Get all the available KYC surveys from the latest template version
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getAllKycSurveyResponse_2'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v4/surveys/kyc/{id}/current': {
    delete?: never;
    /**
     * Get the current KYC surveys and answers, not guaranteed to be the latest questions. Used to view current answers, fetch /all to get latest questions for answering.
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getCurrentKycSurveyResponse'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v4/surveys/kyc/{id}/status': {
    delete?: never;
    /**
     * Get KYC status.
     * @description Get status of survey
     *
     *     ## Links returned
     *
     *     | Attribute                 | Type    | Description    |
     *     | ------------------------- | ------- | -------------- |
     *     | `status`                  | `href`  | Get status.    |
     *     | `questions`               | `href`  | Get questions. |
     *
     *
     *     ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    get: operations['getStatus'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v4/surveys/kyc/status': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    /**
     * KYC survey response status
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:write')`
     */
    put: operations['getKycSurveyStatus_1'];
    trace?: never;
  };
  '/v4/surveys/kyc/status/{partyId}': {
    delete?: never;
    /**
     * KYC survey response status by party ID
     * @description ## Authorization
     *     `hasAuthority('knowYourCustomer:read')`
     */
    get: operations['getKycSurveyStatusByPartyId'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/v4/surveys/kyc/status/pep': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Check if customer is PEP based on their answers
     * @description ## Authorization
     *     `hasAnyAuthority('knowYourCustomer:read', 'knowYourCustomer:write')`
     */
    post: operations['isPep'];
    put?: never;
    trace?: never;
  };
};
export type webhooks = Record<string, never>;
export type components = {
  headers: never;
  parameters: never;
  pathItems: never;
  requestBodies: never;
  responses: never;
  schemas: {
    /** @description A list of groups */
    AdminGroup: {
      /**
       * @description The group id
       * @example TAXES
       */
      id: string;
      /** @description A list of KYC questions */
      questions: components['schemas']['AdminQuestion'][];
      /**
       * @description The group title
       * @example Frågor om skattehemvist
       */
      title: string;
      /**
       * @description The group type
       * @enum {string}
       */
      type: AdminGroupType;
    };
    /** @description List of answering options to choose from */
    AdminOption: {
      /**
       * @description Edd flag for the option
       * @example true
       */
      eddRequired?: boolean;
      /**
       * Format: int32
       * @description The option id
       * @example 1
       */
      id: number;
      /**
       * @description The option text
       * @example Jag har ingen inkomst
       */
      text: string;
    };
    /** @description A list of KYC questions */
    AdminQuestion: {
      displayCondition?: components['schemas']['DisplayCondition'];
      /**
       * Format: int32
       * @description The question id
       * @example 302
       */
      id: number;
      info?: components['schemas']['Info'];
      /** @description Is this question optional */
      optional?: boolean;
      /** @description List of answering options to choose from */
      options?: components['schemas']['AdminOption'][];
      questionMapping?: components['schemas']['QuestionMapping'];
      /**
       * @description The question text
       * @example Vilken är din totala inkomst per månad (före skatt)?
       */
      text: string;
      /**
       * @description The type of question
       * @enum {string}
       */
      type: AdminQuestionType;
    };
    BackfillSurveyResponse: {
      /** @description List of backfilled survey submitted events */
      events?: components['schemas']['KycSurveySubmittedEvent'][];
      /**
       * Format: uuid
       * @description Cursor for the next page: pass as after_customer_id to fetch the next batch. Null when there are no more results.
       * @example 550e8400-e29b-41d4-a716-446655440000
       */
      nextCursor?: string;
    };
    BackfillTemplateResponse: {
      /** @description List of backfilled template updated events */
      events?: components['schemas']['SurveyTemplateUpdatedEvent'][];
    };
    /** @description A list of countries */
    Country: {
      /**
       * @description Country Code
       * @example at
       */
      code: string;
      /**
       * @description Danish Country Name
       * @example Østrig
       */
      nameDk: string;
      /**
       * @description Finnish Country Name
       * @example Itävalta
       */
      nameFi: string;
      /**
       * @description Norwegian Country Name
       * @example Østerrike
       */
      nameNo: string;
      /**
       * @description Swedish Country Name
       * @example Österrike
       */
      nameSe: string;
    };
    CountryListResponse: {
      /** @description A list of countries */
      countries?: components['schemas']['Country'][];
    };
    Customer: {
      partyId?: string;
    };
    CustomerMappedSurveyExportResponse: {
      /**
       * @description The country code according to ISO 3166-1 alpha-2.
       * @example SE
       * @enum {string}
       */
      countryCode?: CustomerMappedSurveyExportResponseCountryCode;
      /**
       * @description Customer type
       * @example NATURAL
       * @enum {string}
       */
      customerType?: CustomerMappedSurveyExportResponseCustomerType;
      /**
       * @description Government Id in long format
       * @example 191212121212
       */
      governmentId?: string;
      /** @description List of mapped survey results for the customer, including the target type, question mapping, and option mapping */
      mappedSurveyResults?: components['schemas']['CustomerSurveyMappingResultDTO'][];
    };
    /** @description List of mapped survey results for the customer, including the target type, question mapping, and option mapping */
    CustomerSurveyMappingResultDTO: {
      /**
       * @description The mapping value for the option
       * @example MONTHLY_INCOME_NONE
       */
      optionMapping?: string;
      /**
       * @description The mapping value for the question
       * @example MONTHLY_INCOME
       */
      questionMapping?: string;
      /**
       * @description The target type for the mapping
       * @example String
       */
      targetType?: string;
    };
    /** @description Specific display condition that may apply to the question */
    DisplayCondition: {
      /**
       * Format: int32
       * @description The option id
       * @example 1
       */
      optionId: number;
      /**
       * Format: int32
       * @description The question id
       * @example 302
       */
      questionId: number;
    };
    ErrorResponse: {
      /**
       * @description Http error code
       * @example 400
       */
      code: string;
      /**
       * @description Message describing the error
       * @example Validation error
       */
      message: string;
      /**
       * @description Timestamp of when error occurred.
       * @example 2019-11-21T09:52:34.678
       */
      timestamp: string;
      /**
       * @description Unique id for this request.
       * @example 033c6a06-1d2c-498f-81a0-02b5f8aac79e
       */
      traceId: string;
    };
    /** @description A list of groups */
    Group: {
      /**
       * Format: date
       * @description Date when the group/account was created
       * @example 2019-12-24
       */
      createdDate?: string;
      /**
       * @description The group id
       * @example TAXES
       */
      id: string;
      /** @description A list KYC questions */
      questions: components['schemas']['Question'][];
      /**
       * @description The group title
       * @example Frågor om skattehemvist
       */
      title: string;
      /**
       * @description The group type
       * @enum {string}
       */
      type: GroupType;
    };
    GroupAnswer: {
      answers?: components['schemas']['QuestionAnswer'][];
      groupId?: string;
      groupType?: string;
    };
    /** @description List of groups that needs new answers */
    GroupToAnswer: {
      /**
       * @description The type of the group that needs new answers
       * @example SAVINGS
       * @enum {string}
       */
      accountType: GroupToAnswerAccountType;
      /** @description The id of the group that needs new answers */
      groupId: string;
    };
    /** @description A list of groups */
    GroupV4: {
      /**
       * Format: date
       * @description Date when the account was created
       * @example 2019-12-24
       */
      createdDate?: string;
      /**
       * @description The group id
       * @example TAXES
       */
      id: string;
      /** @description A list KYC questions */
      questions: components['schemas']['QuestionV4'][];
      /**
       * @description The group title
       * @example Frågor om skattehemvist
       */
      title: string;
      /**
       * @description The group type
       * @enum {string}
       */
      type: GroupV4Type;
    };
    /** @description Additional info text related to the question */
    Info: {
      /**
       * @description Description of the info text
       * @example (Läs mer of FATCA)
       */
      prompt: string;
      /**
       * @description Further explanation of the question, formatted in HTML
       * @example <p>Sverige og USA har inngått en avtale om informasjonsutbytte basert på den amerikanske skatteloven FATCA</p>
       */
      text: string;
    };
    KycSurvey: {
      /** @description A list of groups */
      groups: components['schemas']['Group'][];
      /**
       * @description A signed customer id to be used in the API
       * @example VjAx:MTk5MDAxMDEyMDEwOlNF:Y82fMD34l34qq2dXtzbiBjnKDG6cCtIcfCe1cH23op0
       */
      id: string;
      /**
       * @description Name of the customer for this survey
       * @example John Smith
       */
      title?: string;
    };
    KycSurveyAnswerRequest: {
      /** @description Answers to the KYC survey. First id represents the group id, second id represent the question id along with the answers. */
      answers: {
        [key: string]: {
          [key: string]: string[];
        };
      };
    };
    KycSurveyAnswerV4Request: {
      /** @description Answers to the KYC survey. First id represents the group id, second id represent the question id along with the answers. */
      answers: {
        [key: string]: {
          [key: string]: string[];
        };
      };
      /**
       * Format: int32
       * @description The template version of the survey being answered. Must match the version received from the GET endpoint. Used for validation
       */
      templateVersion: number;
    };
    KycSurveyExpirationStatus: {
      /** @description List of groups that needs new answers */
      groupsNeedingAnswers?: components['schemas']['GroupToAnswer'][];
      /**
       * @description A signed customer id to be used in the API
       * @example VjAx:MTk5MDAxMDEyMDEwOlNF:Y82fMD34l34qq2dXtzbiBjnKDG6cCtIcfCe1cH23op0
       */
      id: string;
    };
    KycSurveyResult: {
      requiresExtraDueDiligence?: boolean;
    };
    /** @description List of backfilled survey submitted events */
    KycSurveySubmittedEvent: {
      customer?: components['schemas']['Customer'];
      /** Format: uuid */
      eventId?: string;
      /** Format: date-time */
      eventTime?: string;
      eventType?: string;
      source?: string;
      survey?: components['schemas']['Survey'];
      template?: components['schemas']['Template'];
      version?: string;
    };
    KycSurveyV4: {
      /** @description A list of groups */
      groups: components['schemas']['GroupV4'][];
      /**
       * @description A signed customer id to be used to identify a survey
       * @example VjAx:MTk5MDAxMDEyMDEwOlNF:Y82fMD34l34qq2dXtzbiBjnKDG6cCtIcfCe1cH23op0
       */
      id: string;
      /**
       * Format: int32
       * @description The template version used to generate this survey
       * @example 3
       */
      templateVersion: number;
      /**
       * @description Name of the customer for this survey
       * @example John Smith
       */
      title?: string;
    };
    OnboardingKycSurveyAnswerRequest: {
      /** @description Account number (product) for which the answers belong to. */
      accountNumber?: string;
      /** @description Answers to the survey. First id represents the group id, second id represent the question id along with the answers. */
      answers: {
        [key: string]: {
          [key: string]: string[];
        };
      };
      companyRequest?: boolean;
      /** @description Government id of the customer to onboard. */
      governmentId: string;
    };
    OnboardingKycSurveyAnswerV4Request: {
      /** @description Account number (product) for which the answers belong to. */
      accountNumber?: string;
      /** @description Answers to the survey. First id represent the group id, second id represent the question id along with the answers. */
      answers: {
        [key: string]: {
          [key: string]: string[];
        };
      };
      companyRequest?: boolean;
      /** @description Government id of the customer to onboard. */
      governmentId: string;
      /**
       * Format: int32
       * @description The template version of the survey being answered. Must match the version received from the GET endpoint.
       */
      templateVersion: number;
    };
    /** @description List of answering options to choose from */
    Option: {
      /**
       * Format: int32
       * @description The option id
       * @example 1
       */
      id: number;
      /**
       * @description The option text
       * @example Jag har ingen inkomst
       */
      text: string;
    };
    /** @description List of option mappings for the question's options */
    OptionMapping: {
      /**
       * @description The mapping value for the option
       * @example 10000
       */
      mapping: string;
      /**
       * Format: int32
       * @description The option id
       * @example 1
       */
      optionId: number;
    };
    Page: {
      content?: Record<string, never>[];
      empty?: boolean;
      first?: boolean;
      last?: boolean;
      /** Format: int32 */
      number?: number;
      /** Format: int32 */
      numberOfElements?: number;
      pageable?: components['schemas']['PageableObject'];
      /** Format: int32 */
      size?: number;
      sort?: components['schemas']['SortObject'];
      /** Format: int64 */
      totalElements?: number;
      /** Format: int32 */
      totalPages?: number;
    };
    Pageable: {
      /** Format: int32 */
      page?: number;
      /** Format: int32 */
      size?: number;
      sort?: string[];
    };
    PageableObject: {
      /** Format: int64 */
      offset?: number;
      paged?: boolean;
      /** Format: int32 */
      pageNumber?: number;
      /** Format: int32 */
      pageSize?: number;
      sort?: components['schemas']['SortObject'];
      unpaged?: boolean;
    };
    /** @description PEP status for a customer */
    PepStatus: {
      /**
       * @description Country Code
       * @example SE
       */
      countryCode: string;
      /**
       * @description Government id
       * @example 191212121212
       */
      governmentId: string;
      /**
       * @description Indicates whether the customer is identified as a PEP based on their survey answers
       * @example true
       */
      pep: boolean;
    };
    /** @description A list KYC questions */
    Question: {
      displayCondition?: components['schemas']['DisplayCondition'];
      /** @description Existing answers to the question */
      existingAnswers?: string[];
      /**
       * Format: int32
       * @description The question id
       * @example 302
       */
      id: number;
      info?: components['schemas']['Info'];
      /**
       * @description Whether the question is optional
       * @example false
       */
      optional?: boolean;
      /** @description List of answering options to choose from */
      options?: components['schemas']['Option'][];
      /**
       * @description The question text
       * @example Vilken är din totala inkomst per månad (före skatt)?
       */
      text: string;
      /** @description Regex to validate the answer */
      textValidationRegex?: string;
      /**
       * @description The type of question
       * @enum {string}
       */
      type: QuestionType;
    };
    QuestionAnswer: {
      /** Format: date-time */
      answeredAt?: string;
      /** Format: uuid */
      id?: string;
      /** Format: int32 */
      questionId?: number;
      questionText?: string;
      selectedOptions?: components['schemas']['SelectedOption'][];
    };
    /** @description List of question mappings for the template */
    QuestionMapping: {
      /**
       * @description The mapping value for the question
       * @example MONTHLY_INCOME
       */
      mapping: string;
      /** @description List of option mappings for the question's options */
      optionMappings?: components['schemas']['OptionMapping'][];
      /**
       * Format: int32
       * @description The question id
       * @example 302
       */
      questionId: number;
      /**
       * @description The target type for the mapping
       * @example Int
       * @enum {string}
       */
      targetType: QuestionMappingTargetType;
    };
    /** @description A list KYC questions */
    QuestionV4: {
      displayCondition?: components['schemas']['DisplayCondition'];
      /**
       * Format: int32
       * @description The question id
       * @example 302
       */
      id: number;
      info?: components['schemas']['Info'];
      /**
       * @description Whether the question is optional
       * @example false
       */
      optional?: boolean;
      /** @description List of answering options to choose from */
      options?: components['schemas']['Option'][];
      /**
       * @description The question text
       * @example Vilken är din totala inkomst per månad (före skatt)?
       */
      text: string;
      /**
       * @description The type of question
       * @enum {string}
       */
      type: QuestionV4Type;
    };
    SearchCustomerAnswersRequest: {
      /**
       * @description The country code according to ISO 3166-1 alpha-2.
       * @example SE
       */
      countryCode: string;
      /**
       * @description The government id.
       * @example 191212121212
       */
      governmentId: string;
    };
    SelectedOption: {
      /** Format: int32 */
      optionId?: number;
      text?: string;
    };
    SortObject: {
      empty?: boolean;
      sorted?: boolean;
      unsorted?: boolean;
    };
    Status: {
      /**
       * @deprecated
       * @description This is only now(), dont use this
       */
      completionDate?: string;
      /** @description List of groups that needs new answers */
      groupsNeedingAnswers?: components['schemas']['GroupToAnswer'][];
      /**
       * @description A signed customer id to be used in the API
       * @example VjAx:MTk5MDAxMDEyMDEwOlNF:Y82fMD34l34qq2dXtzbiBjnKDG6cCtIcfCe1cH23op0
       */
      id: string;
      /**
       * @description If there are kyc questions available to answer
       * @example true
       */
      surveyAvailable: boolean;
      /**
       * Format: int32
       * @deprecated
       * @description Number of times to skip answering the kyc questions before they become mandatory
       * @example 0
       */
      timesLeftToDismiss: number;
    };
    StatusRequest: {
      /**
       * @description Country Code
       * @example SE
       */
      countryCode: string;
      /**
       * @description Government id
       * @example 199001012010
       */
      governmentId: string;
    };
    StatusV4: {
      /** @description List of groups that needs new answers */
      groupsNeedingAnswers?: components['schemas']['GroupToAnswer'][];
      /**
       * @description A signed customer id to be used in the API
       * @example VjAx:MTk5MDAxMDEyMDEwOlNF:Y82fMD34l34qq2dXtzbiBjnKDG6cCtIcfCe1cH23op0
       */
      id: string;
      /**
       * @description If there are kyc questions available to answer
       * @example true
       */
      surveyAvailable: boolean;
    };
    Survey: {
      groups?: components['schemas']['GroupAnswer'][];
    };
    /** @description The survey template */
    SurveyTemplate: {
      /**
       * @description Country Code
       * @example SE
       */
      countryCode: string;
      /**
       * @description The user who created this template
       * @example admin@resurs.se
       */
      createdBy?: string;
      /**
       * @description Customer type
       * @example NATURAL
       * @enum {string}
       */
      customerType: SurveyTemplateCustomerType;
      /** @description A list of groups */
      groups: components['schemas']['AdminGroup'][];
      /**
       * Format: int32
       * @description Template version
       * @example 1
       */
      version?: number;
    };
    /** @description List of backfilled template updated events */
    SurveyTemplateUpdatedEvent: {
      /** Format: uuid */
      eventId?: string;
      /** Format: date-time */
      eventTime?: string;
      eventType?: string;
      questionMappings?: components['schemas']['QuestionMapping'][];
      source?: string;
      template?: components['schemas']['Template'];
      version?: string;
    };
    SurveyTemplateWithMapping: {
      surveyTemplate: components['schemas']['SurveyTemplate'];
      templateMapping: components['schemas']['TemplateMapping'];
    };
    Template: {
      countryCode?: string;
      customerType?: string;
      /** Format: int32 */
      version?: number;
    };
    TemplateMapping: {
      /** @description List of question mappings for the template */
      questionMappings: components['schemas']['QuestionMapping'][];
    };
    UpdateCustomerAnswerRequest: {
      /**
       * @description The date the answer will be deleted. Valid delete dates are between 5 years to 10 years from the date the answer was given by the customer.
       * @example 2028-12-14T13:00:00Z
       */
      deleteDate: string;
    };
    /** @description List of validation errors */
    ValidationError: {
      /**
       * @description Name of offending field in payload.
       * @example email
       */
      fieldName: string;
      /**
       * @description Message describing the validation error.
       * @example Email address must contain '@' character.
       */
      message: string;
    };
    ValidationErrorResponse: {
      /**
       * @description Http error code
       * @example 400
       */
      code: string;
      /**
       * @description Message describing the error
       * @example Validation error
       */
      message: string;
      /**
       * @description Timestamp of when error occurred.
       * @example 2019-11-21T09:52:34.678
       */
      timestamp: string;
      /**
       * @description Unique id for this request.
       * @example 033c6a06-1d2c-498f-81a0-02b5f8aac79e
       */
      traceId: string;
      /** @description List of validation errors */
      validationErrors?: components['schemas']['ValidationError'][];
    };
  };
};
export type ErrorResponse = components['schemas']['ErrorResponse'];
export type ValidationError = components['schemas']['ValidationError'];
export type ValidationErrorResponse =
  components['schemas']['ValidationErrorResponse'];
export type GroupToAnswer = components['schemas']['GroupToAnswer'];
export type Status = components['schemas']['Status'];
export type StatusRequest = components['schemas']['StatusRequest'];
export type OptionMapping = components['schemas']['OptionMapping'];
export type QuestionMapping = components['schemas']['QuestionMapping'];
export type TemplateMapping = components['schemas']['TemplateMapping'];
export type SearchCustomerAnswersRequest =
  components['schemas']['SearchCustomerAnswersRequest'];
export type Page = components['schemas']['Page'];
export type PageableObject = components['schemas']['PageableObject'];
export type SortObject = components['schemas']['SortObject'];
export type Pageable = components['schemas']['Pageable'];
export type PepStatus = components['schemas']['PepStatus'];
export type Country = components['schemas']['Country'];
export type CountryListResponse = components['schemas']['CountryListResponse'];
export type UpdateCustomerAnswerRequest =
  components['schemas']['UpdateCustomerAnswerRequest'];
export type KycSurveyAnswerV4Request =
  components['schemas']['KycSurveyAnswerV4Request'];
export type KycSurveyResult = components['schemas']['KycSurveyResult'];
export type OnboardingKycSurveyAnswerRequest =
  components['schemas']['OnboardingKycSurveyAnswerRequest'];
export type AdminGroup = components['schemas']['AdminGroup'];
export type AdminOption = components['schemas']['AdminOption'];
export type AdminQuestion = components['schemas']['AdminQuestion'];
export type DisplayCondition = components['schemas']['DisplayCondition'];
export type Info = components['schemas']['Info'];
export type SurveyTemplate = components['schemas']['SurveyTemplate'];
export type SurveyTemplateWithMapping =
  components['schemas']['SurveyTemplateWithMapping'];
export type GroupV4 = components['schemas']['GroupV4'];
export type KycSurveyV4 = components['schemas']['KycSurveyV4'];
export type Option = components['schemas']['Option'];
export type QuestionV4 = components['schemas']['QuestionV4'];
export type Group = components['schemas']['Group'];
export type KycSurvey = components['schemas']['KycSurvey'];
export type Question = components['schemas']['Question'];
export type KycSurveyExpirationStatus =
  components['schemas']['KycSurveyExpirationStatus'];
export type KycSurveyAnswerRequest =
  components['schemas']['KycSurveyAnswerRequest'];
export type StatusV4 = components['schemas']['StatusV4'];
export type CustomerMappedSurveyExportResponse =
  components['schemas']['CustomerMappedSurveyExportResponse'];
export type CustomerSurveyMappingResultDTO =
  components['schemas']['CustomerSurveyMappingResultDTO'];
export type OnboardingKycSurveyAnswerV4Request =
  components['schemas']['OnboardingKycSurveyAnswerV4Request'];
export type BackfillSurveyResponse =
  components['schemas']['BackfillSurveyResponse'];
export type Customer = components['schemas']['Customer'];
export type GroupAnswer = components['schemas']['GroupAnswer'];
export type KycSurveySubmittedEvent =
  components['schemas']['KycSurveySubmittedEvent'];
export type QuestionAnswer = components['schemas']['QuestionAnswer'];
export type SelectedOption = components['schemas']['SelectedOption'];
export type Survey = components['schemas']['Survey'];
export type Template = components['schemas']['Template'];
export type BackfillTemplateResponse =
  components['schemas']['BackfillTemplateResponse'];
export type SurveyTemplateUpdatedEvent =
  components['schemas']['SurveyTemplateUpdatedEvent'];
export type $defs = Record<string, never>;
export type operations = {
  backfillSurveys: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: {
        /** @description Cursor: customer UUID to start after (exclusive). Omit or empty for first page. */
        after_customer_id?: string;
        /**
         * @description Customer type filter (NATURAL or LEGAL)
         * @example NATURAL
         */
        customer_type?: PathsExportBackfillSurveysGetParametersQueryCustomer_type;
        /**
         * @description Number of customers per page (1-1000)
         * @example 100
         */
        size?: number;
      };
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['BackfillSurveyResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['ValidationErrorResponse']
            | components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  backfillTemplates: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['BackfillTemplateResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['ValidationErrorResponse']
            | components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  export: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query: {
        /**
         * @description Export from id (exclusive)
         * @example 0
         */
        from_id: number;
        pageable: components['schemas']['Pageable'];
      };
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['Page'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['ValidationErrorResponse']
            | components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  exportPdf: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SearchCustomerAnswersRequest'];
      };
    };
    responses: {
      /** @description Ok */
      200: {
        content: {
          '*/*': string;
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getAllCountries: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['CountryListResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['ValidationErrorResponse']
            | components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getAllKycSurveyResponse: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A signed customer id */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurvey'][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getAllKycSurveyResponse_1: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A signed customer id */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurvey'][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getAllKycSurveyResponse_2: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A signed customer id */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurveyV4'][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getAllSurveys: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description Party ID from PRDD */
        partyId: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurveyV4'][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getCurrentKycSurveyResponse: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A signed customer id */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurvey'][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getCustomerAnswers: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: {
        /** @description Zero-based page index (0..N) */
        page?: number;
        /** @description The size of the page to be returned */
        size?: number;
        /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
        sort?: string[];
      };
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SearchCustomerAnswersRequest'];
      };
    };
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['Page'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getExpirationStatus: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StatusRequest'];
      };
    };
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurveyExpirationStatus'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getExpirationStatus_1: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StatusRequest'];
      };
    };
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurveyExpirationStatus'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getKycSurveyForNewAccount: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description Country code */
        country_code: string;
      };
      query: {
        /** @description Type of new account to fetch questions for */
        account_type: PathsV4SurveysKycCountry_codeOnboardingGetParametersQueryAccount_type;
        /** @description Filter type for getting a specific group of questions */
        filter_type?: PathsV4SurveysKycCountry_codeOnboardingGetParametersQueryFilter_type;
        /** @description Government id of the customer to onboard. When provided, previously answered questions within the validity period are excluded from the survey. When omitted, the full survey is returned. */
        government_id?: string;
      };
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurveyV4'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getKycSurveyResponse: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A signed customer id */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurveyV4'][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getKycSurveyResponse_1: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A signed customer id */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurvey'][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getKycSurveyResponse_2: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A signed customer id */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurvey'][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getKycSurveyResponseForNewAccount: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description Country code */
        country_code: string;
      };
      query: {
        /** @description Type of new account to fetch questions for */
        account_type: PathsSurveysKycCountry_codeOnboardingGetParametersQueryAccount_type;
        /** @description Filter type for getting a specific group of questions */
        filter_type?: PathsSurveysKycCountry_codeOnboardingGetParametersQueryFilter_type;
        /** @description Government id of the customer to onboard */
        government_id?: string;
      };
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurvey'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getKycSurveyStatus: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StatusRequest'];
      };
    };
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['Status'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getKycSurveyStatus_1: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StatusRequest'];
      };
    };
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['StatusV4'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getKycSurveyStatus_2: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StatusRequest'];
      };
    };
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['Status'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getKycSurveyStatusByPartyId: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description Party ID from PRDD */
        partyId: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['StatusV4'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getLegalCustomerMappedSurveyExport: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /**
         * @description LedId of the legal customer
         * @example SE9696935023
         */
        ledId: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['CustomerMappedSurveyExportResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['ValidationErrorResponse']
            | components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getNaturalCustomerMappedSurveyExport: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /**
         * @description PartyID of the natural customer
         * @example j2JVyttAwyRXLOJMKnEA4e98
         */
        partyId: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['CustomerMappedSurveyExportResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['ValidationErrorResponse']
            | components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getStatus: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A signed customer id */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['Status'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getStatus_1: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A signed customer id */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['Status'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getStatus_2: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A signed customer id */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['Status'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getSurveys: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description Party ID from PRDD */
        partyId: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurveyV4'][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getSurveyTemplate: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description Country code */
        country_code: string;
        /** @description Customer type */
        customer_type: PathsV2AdminSurveyCountry_codeCustomer_typeGetParametersPathCustomer_type;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['SurveyTemplate'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getTemplateMappings: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /**
         * @description Country code
         * @example SE
         */
        country_code: string;
        /**
         * @description Customer type
         * @example NATURAL
         */
        customer_type: PathsV2AdminMappingCountry_codeCustomer_typeVersionGetParametersPathCustomer_type;
        /**
         * @description Template version
         * @example 1
         */
        version: number;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['TemplateMapping'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getWithdrawalSurvey: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description Country code */
        country_code: string;
      };
      query: {
        /** @description Amount to withdraw */
        withdrawal_amount: number;
      };
    };
    requestBody?: never;
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['KycSurvey'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  isPep: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StatusRequest'];
      };
    };
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': components['schemas']['PepStatus'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  postKycSurveyResponse: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A signed customer id */
        id: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['KycSurveyAnswerV4Request'];
      };
    };
    responses: {
      /** @description Ok */
      200: {
        content: {
          '*/*': components['schemas']['KycSurveyResult'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  postKycSurveyResponse_1: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description Country code */
        country_code: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OnboardingKycSurveyAnswerRequest'];
      };
    };
    responses: {
      /** @description No Content */
      204: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  postKycSurveyResponse_2: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A signed customer id */
        id: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['KycSurveyAnswerRequest'];
      };
    };
    responses: {
      /** @description Ok */
      200: {
        content: {
          '*/*': components['schemas']['KycSurveyResult'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  postKycSurveyResponse_3: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description Country code */
        country_code: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OnboardingKycSurveyAnswerV4Request'];
      };
    };
    responses: {
      /** @description Ok */
      200: {
        content: {
          '*/*': components['schemas']['KycSurveyResult'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  postKycSurveyResponse_4: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description A signed customer id */
        id: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['KycSurveyAnswerRequest'];
      };
    };
    responses: {
      /** @description No Content */
      204: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  postKycSurveyResponse_5: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description Country code */
        country_code: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OnboardingKycSurveyAnswerRequest'];
      };
    };
    responses: {
      /** @description Ok */
      200: {
        content: {
          '*/*': components['schemas']['KycSurveyResult'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  postSurveyTemplate: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SurveyTemplateWithMapping'];
      };
    };
    responses: {
      /** @description Ok */
      200: {
        content: {
          'application/json': number;
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  postWithdrawalSurveyResponse: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description Country code */
        country_code: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OnboardingKycSurveyAnswerRequest'];
      };
    };
    responses: {
      /** @description No Content */
      204: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  updateDeleteDate: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /**
         * @description The answer id.
         * @example 3
         */
        answer_id: number;
        /**
         * @description The customer id.
         * @example VjAx:U0U6U0U:x-1xe7sW-2hFFmg62d0r5T0VCrly_a1D9LVIV3yNW2w
         */
        customer_id: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateCustomerAnswerRequest'];
      };
    };
    responses: {
      /** @description No Content */
      204: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Gateway */
      502: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
};
export enum PathsV2AdminMappingCountry_codeCustomer_typeVersionGetParametersPathCustomer_type {
  NATURAL = 'NATURAL',
  LEGAL = 'LEGAL',
}
export enum PathsSurveysKycCountry_codeOnboardingGetParametersQueryAccount_type {
  SAVINGS = 'SAVINGS',
  CORPORATE_SAVINGS = 'CORPORATE_SAVINGS',
  PRIVATE_LOAN = 'PRIVATE_LOAN',
  CREDIT = 'CREDIT',
  INVOICE = 'INVOICE',
  SALARY_ACCOUNT = 'SALARY_ACCOUNT',
  SALARY_ACCOUNT_CARD = 'SALARY_ACCOUNT_CARD',
}
export enum PathsSurveysKycCountry_codeOnboardingGetParametersQueryFilter_type {
  NONE = 'NONE',
  PEP = 'PEP',
}
export enum PathsV4SurveysKycCountry_codeOnboardingGetParametersQueryAccount_type {
  SAVINGS = 'SAVINGS',
  CORPORATE_SAVINGS = 'CORPORATE_SAVINGS',
  PRIVATE_LOAN = 'PRIVATE_LOAN',
  CREDIT = 'CREDIT',
  INVOICE = 'INVOICE',
  SALARY_ACCOUNT = 'SALARY_ACCOUNT',
  SALARY_ACCOUNT_CARD = 'SALARY_ACCOUNT_CARD',
}
export enum PathsV4SurveysKycCountry_codeOnboardingGetParametersQueryFilter_type {
  NONE = 'NONE',
  PEP = 'PEP',
}
export enum PathsExportBackfillSurveysGetParametersQueryCustomer_type {
  NATURAL = 'NATURAL',
  LEGAL = 'LEGAL',
}
export enum PathsV2AdminSurveyCountry_codeCustomer_typeGetParametersPathCustomer_type {
  NATURAL = 'NATURAL',
  LEGAL = 'LEGAL',
}
export enum GroupToAnswerAccountType {
  ECONOMY = 'ECONOMY',
  TAXES = 'TAXES',
  PEP = 'PEP',
  SAVINGS = 'SAVINGS',
  CORPORATE_SAVINGS = 'CORPORATE_SAVINGS',
  LOANS = 'LOANS',
  CREDIT_CARDS = 'CREDIT_CARDS',
  CITIZENSHIP = 'CITIZENSHIP',
  SALARY_ACCOUNT = 'SALARY_ACCOUNT',
  SALARY_ACCOUNT_CARD = 'SALARY_ACCOUNT_CARD',
  WITHDRAWAL = 'WITHDRAWAL',
  COMPANY = 'COMPANY',
  OWNERSHIP_AND_CONTROL = 'OWNERSHIP_AND_CONTROL',
}
export enum QuestionMappingTargetType {
  String = 'String',
  Int = 'Int',
  Double = 'Double',
  DateTime = 'DateTime',
  Boolean = 'Boolean',
}
export enum AdminGroupType {
  ECONOMY = 'ECONOMY',
  TAXES = 'TAXES',
  PEP = 'PEP',
  SAVINGS = 'SAVINGS',
  CORPORATE_SAVINGS = 'CORPORATE_SAVINGS',
  LOANS = 'LOANS',
  CREDIT_CARDS = 'CREDIT_CARDS',
  CITIZENSHIP = 'CITIZENSHIP',
  SALARY_ACCOUNT = 'SALARY_ACCOUNT',
  SALARY_ACCOUNT_CARD = 'SALARY_ACCOUNT_CARD',
  WITHDRAWAL = 'WITHDRAWAL',
  COMPANY = 'COMPANY',
  OWNERSHIP_AND_CONTROL = 'OWNERSHIP_AND_CONTROL',
}
export enum AdminQuestionType {
  SINGLE_SELECTION = 'SINGLE_SELECTION',
  MULTIPLE_SELECTION = 'MULTIPLE_SELECTION',
  FREE_TEXT = 'FREE_TEXT',
  BUTTON = 'BUTTON',
  COUNTRY_CODE_SELECTION = 'COUNTRY_CODE_SELECTION',
  CHECK_BOX = 'CHECK_BOX',
  SINGLE_SELECTION_DROPDOWN = 'SINGLE_SELECTION_DROPDOWN',
  MULTIPLE_COUNTRY_CODE_SELECTION = 'MULTIPLE_COUNTRY_CODE_SELECTION',
}
export enum SurveyTemplateCustomerType {
  NATURAL = 'NATURAL',
  LEGAL = 'LEGAL',
}
export enum GroupV4Type {
  ECONOMY = 'ECONOMY',
  TAXES = 'TAXES',
  PEP = 'PEP',
  SAVINGS = 'SAVINGS',
  CORPORATE_SAVINGS = 'CORPORATE_SAVINGS',
  LOANS = 'LOANS',
  CREDIT_CARDS = 'CREDIT_CARDS',
  CITIZENSHIP = 'CITIZENSHIP',
  SALARY_ACCOUNT = 'SALARY_ACCOUNT',
  SALARY_ACCOUNT_CARD = 'SALARY_ACCOUNT_CARD',
  WITHDRAWAL = 'WITHDRAWAL',
  COMPANY = 'COMPANY',
  OWNERSHIP_AND_CONTROL = 'OWNERSHIP_AND_CONTROL',
}
export enum QuestionV4Type {
  SINGLE_SELECTION = 'SINGLE_SELECTION',
  MULTIPLE_SELECTION = 'MULTIPLE_SELECTION',
  FREE_TEXT = 'FREE_TEXT',
  BUTTON = 'BUTTON',
  COUNTRY_CODE_SELECTION = 'COUNTRY_CODE_SELECTION',
  CHECK_BOX = 'CHECK_BOX',
  SINGLE_SELECTION_DROPDOWN = 'SINGLE_SELECTION_DROPDOWN',
  MULTIPLE_COUNTRY_CODE_SELECTION = 'MULTIPLE_COUNTRY_CODE_SELECTION',
}
export enum GroupType {
  ECONOMY = 'ECONOMY',
  TAXES = 'TAXES',
  PEP = 'PEP',
  SAVINGS = 'SAVINGS',
  CORPORATE_SAVINGS = 'CORPORATE_SAVINGS',
  LOANS = 'LOANS',
  CREDIT_CARDS = 'CREDIT_CARDS',
  CITIZENSHIP = 'CITIZENSHIP',
  SALARY_ACCOUNT = 'SALARY_ACCOUNT',
  SALARY_ACCOUNT_CARD = 'SALARY_ACCOUNT_CARD',
  WITHDRAWAL = 'WITHDRAWAL',
  COMPANY = 'COMPANY',
  OWNERSHIP_AND_CONTROL = 'OWNERSHIP_AND_CONTROL',
}
export enum QuestionType {
  SINGLE_SELECTION = 'SINGLE_SELECTION',
  MULTIPLE_SELECTION = 'MULTIPLE_SELECTION',
  FREE_TEXT = 'FREE_TEXT',
  BUTTON = 'BUTTON',
  COUNTRY_CODE_SELECTION = 'COUNTRY_CODE_SELECTION',
  CHECK_BOX = 'CHECK_BOX',
  SINGLE_SELECTION_DROPDOWN = 'SINGLE_SELECTION_DROPDOWN',
  MULTIPLE_COUNTRY_CODE_SELECTION = 'MULTIPLE_COUNTRY_CODE_SELECTION',
}
export enum CustomerMappedSurveyExportResponseCountryCode {
  SE = 'SE',
  NO = 'NO',
  DK = 'DK',
  FI = 'FI',
  UNKNOWN = 'UNKNOWN',
}
export enum CustomerMappedSurveyExportResponseCustomerType {
  NATURAL = 'NATURAL',
  LEGAL = 'LEGAL',
}
